module.exports = __webpack_public_path__ + "static/media/heinzGallerie.62ef1fb9.jpg";